
import {
	Component,
	Inject,
	OnInit,
	AfterViewInit,
	Input,
} from "@angular/core";
import { IColunasGrid, IMatrizRiscoControle, IMatrizRiscoControleAssociado, IMatrizRiscoControleRisco } from "../../model/matriz-risco-controle.model";
import { ControleService } from "src/app/services/controle.service";
import { IControle } from "src/app/models/controle.model";
import { NiveisRiscoResidualService } from "src/app/services/niveis-risco-residual.service";
import { FormulaRiscoResidualService } from "src/app/services/formula-risco-residual.service";
import { BaseListComponent } from "src/app/shared/components/base-list/base-list.component";
@Component({
	selector: "app-mr-aba-controle",
	templateUrl: "./mr-aba-controle.component.html",
	styleUrls: ["./mr-aba-controle.component.scss"],
})
export class MrAbaControleComponent extends BaseListComponent implements OnInit, AfterViewInit {
	@Input() objPrincipal!: IMatrizRiscoControle;
	@Input() visualizar: boolean;

	objEditar!: IMatrizRiscoControleAssociado;
	dataSource!: any;
	listColunas: IColunasGrid[] = [
		{ id: "posicao", label: "Ref" },
		{ id: "descricao", label: "Descrição" },
		{ id: "descricaoRisco", label: "Risco Identificado" }
	];

	riscoSelecionado!: number;

	txtDescricaoControle!: string;
	txtValorRR!: any;
	txtCalculoRR!: string;
	txtNivelRR!: string;
	txtMelhorPratica!: string;

	avaliacaoControleSelecionada!: number;
	listAvaliacaoControle!: IControle[];

	listNiveisRR!: any[];
	formulaRR!: any;

	constructor(
		private controleService: ControleService,
		private nivelRRService: NiveisRiscoResidualService,
		private formulaService: FormulaRiscoResidualService) {
		super();
	}

	ngOnInit(): void {

	}

	ngAfterViewInit() {

	}

	setRisco() {
		if (this.riscoSelecionado == undefined || this.riscoSelecionado == 0) {
			this.riscoSelecionado = this.objPrincipal.riscos[0].controle;
		}
	}

	changeRisco() {
		this.calcular();
	}

	changeAvaliacao() {
		this.txtValorRR = "";
		this.txtNivelRR = "";
		this.txtCalculoRR = "";

		if (this.avaliacaoControleSelecionada > 0) {
			this.txtValorRR = this.listAvaliacaoControle.find(f => f.id == this.avaliacaoControleSelecionada).valorDoRisco;
			this.calcular();
		}
	}

	carregaControles() {
		this.controleService.obter(this.objPrincipal.idCriterioAvaliacao.toString(), true, true).then((res) => {
			this.listAvaliacaoControle = [{ id: 0, avaliacao: "Selecione" }].concat(res?.dados) as IControle[];
			this.carregaNiveisRR();
		})
	}

	carregaNiveisRR() {
		this.nivelRRService.obter(this.objPrincipal.idCriterioAvaliacao.toString(), true, true).then((res) => {
			this.listNiveisRR = res?.dados;
			this.carregaFormulaRR();
		});
	}

	carregaFormulaRR() {
		this.formulaService.obter(this.objPrincipal.idCriterioAvaliacao.toString(), true, true).then((res) => {
			this.formulaRR = res?.dados[0];
		});
	}

	calcular() {
		//console.log("calcular");

		let obj = this.objPrincipal.riscos.find(f => f.controle == this.riscoSelecionado);
		let valorRR = parseFloat(this.txtValorRR.replace(',', '.'));

		//console.log(obj);
		//console.log("valorRR:" + valorRR);
		//console.log(this.formulaRR);

		let resultado: any;
		switch (this.formulaRR.operador) {
			case '+':
				resultado = obj.resultadoRI + valorRR;
				break;
			case '-':
				resultado = obj.resultadoRI - valorRR;
				break;
			case '*':
				resultado = obj.resultadoRI * valorRR;
				break;
			case '/':
				if (obj.resultadoRI !== 0 && valorRR !== 0) {
					resultado = (obj.resultadoRI / valorRR);
				} else {
					console.warn("Divisão por zero não permitida!");
				}
				break;
			default:
				resultado = 0;
				console.warn(`Operador "${this.formulaRR.operador}" não reconhecido!`);
				return;
		}

		//console.log(resultado);
		//console.log(this.listNiveisRR);

		for (const criterio of this.listNiveisRR) {
			const valor = parseFloat(criterio.valor);
			const valor1 = criterio.valor_1 ? parseFloat(criterio.valor_1) : undefined;

			let condicao1 = false;
			let condicao2 = criterio.operador_1 && valor1 !== undefined ? false : true;

			switch (criterio.operador) {
				case "=":
					condicao1 = resultado === valor;
					break;
				case "!=":
					condicao1 = resultado !== valor;
					break;
				case ">":
					condicao1 = resultado > valor;
					break;
				case "<":
					condicao1 = resultado < valor;
					break;
				case ">=":
					condicao1 = resultado >= valor;
					break;
				case "<=":
					condicao1 = resultado <= valor;
					break;
			}

			if (criterio.operador_1 && valor1 !== undefined) {
				switch (criterio.operador_1) {
					case "=":
						condicao2 = resultado === valor1;
						break;
					case "!=":
						condicao2 = resultado !== valor1;
						break;
					case ">":
						condicao2 = resultado > valor1;
						break;
					case "<":
						condicao2 = resultado < valor1;
						break;
					case ">=":
						condicao2 = resultado >= valor1;
						break;
					case "<=":
						condicao2 = resultado <= valor1;
						break;
				}
			}

			//console.log("condicao1:" + condicao1);
			//console.log("condicao2:" + condicao2);

			if (condicao1 && condicao2) {
				this.txtNivelRR = criterio.nome;
				this.txtCalculoRR = resultado.toString();
			}
		}
	}

	importar(id : number): any {
		if (this.objPrincipal.riscos.length === 1) {
			this.riscoSelecionado = this.objPrincipal.riscos[0].controle;
		}

		if (this.riscoSelecionado == 0 || this.riscoSelecionado == undefined) {
			this.exibirMensagemAlerta("Selecione o Risco Identificado!");
			return;
		}

		if (this.txtDescricaoControle == undefined || this.txtDescricaoControle == "") {
			this.exibirMensagemAlerta("Informe a Descrição do Controle!");
			return;
		}

		if (this.txtDescricaoControle != "" && this.txtDescricaoControle != undefined) {
			if (this.txtDescricaoControle.length < 10 || this.txtDescricaoControle.length > 255) {
				this.exibirMensagemAlerta("A Descrição do Controle deve ter entre 10 e 255 caracteres!");
				return;
			}
		}

		if (this.txtMelhorPratica != "" && this.txtMelhorPratica != undefined) {
			if (this.txtMelhorPratica.length < 10 || this.txtMelhorPratica.length > 255) {
				this.exibirMensagemAlerta("A Descrição da Melhor Prática deve ter entre 10 e 255 caracteres!");
				return;
			}
		}

		if (this.avaliacaoControleSelecionada == 0 || this.avaliacaoControleSelecionada == undefined) {
			this.exibirMensagemAlerta("Selecione a Avaliação!");
			return;
		}

		if (this.objPrincipal.riscos == null)
			this.objPrincipal.riscos = [];

		const nova: IMatrizRiscoControleAssociado = {} as IMatrizRiscoControleAssociado;
		nova.id = 0;
		nova.descricao = this.txtDescricaoControle;
		nova.descricaoMelhorPratica = this.txtMelhorPratica;
		nova.idControle = this.avaliacaoControleSelecionada;
		nova.descricaoControle = this.listAvaliacaoControle.find(f => f.id == this.avaliacaoControleSelecionada).avaliacao;
		nova.valorRI = this.txtValorRR;
		nova.valorCalculado = this.txtCalculoRR;
		nova.nivelRR = this.txtNivelRR;
		nova.controleRiscoControleRiscos = this.riscoSelecionado;
		nova.descricaoRisco = this.objPrincipal.riscos.find(f => f.controle == this.riscoSelecionado).descricaoRisco;
		nova.posicao = this.objPrincipal.associados.length + 1;
		nova.controle = id;

		this.objPrincipal.associados.push(nova);		
		this.objPrincipal.associados = [...this.objPrincipal.associados];
		
		this.limpar();
		return this.objPrincipal.associados;
	}

	adicionar(): any {
		if (this.objPrincipal.riscos.length === 1) {
			this.riscoSelecionado = this.objPrincipal.riscos[0].controle;
		}

		if (this.riscoSelecionado == 0 || this.riscoSelecionado == undefined) {
			this.exibirMensagemAlerta("Selecione o Risco Identificado!");
			return;
		}

		if (this.txtDescricaoControle == undefined || this.txtDescricaoControle == "") {
			this.exibirMensagemAlerta("Informe a Descrição do Controle!");
			return;
		}

		if (this.txtDescricaoControle != "" && this.txtDescricaoControle != undefined) {
			if (this.txtDescricaoControle.length < 10 || this.txtDescricaoControle.length > 255) {
				this.exibirMensagemAlerta("A Descrição do Controle deve ter entre 10 e 255 caracteres!");
				return;
			}
		}

		if (this.txtMelhorPratica != "" && this.txtMelhorPratica != undefined) {
			if (this.txtMelhorPratica.length < 10 || this.txtMelhorPratica.length > 255) {
				this.exibirMensagemAlerta("A Descrição da Melhor Prática deve ter entre 10 e 255 caracteres!");
				return;
			}
		}

		if (this.avaliacaoControleSelecionada == 0 || this.avaliacaoControleSelecionada == undefined) {
			this.exibirMensagemAlerta("Selecione a Avaliação!");
			return;
		}

		if (this.objPrincipal.riscos == null)
			this.objPrincipal.riscos = [];

		if (this.objEditar == null) {
			const nova: IMatrizRiscoControleAssociado = {} as IMatrizRiscoControleAssociado;
			nova.id = 0;
			nova.descricao = this.txtDescricaoControle;
			nova.descricaoMelhorPratica = this.txtMelhorPratica;
			nova.idControle = this.avaliacaoControleSelecionada;
			nova.descricaoControle = this.listAvaliacaoControle.find(f => f.id == this.avaliacaoControleSelecionada).avaliacao;
			nova.valorRI = this.txtValorRR;
			nova.valorCalculado = this.txtCalculoRR;
			nova.nivelRR = this.txtNivelRR;
			nova.controleRiscoControleRiscos = this.riscoSelecionado;
			nova.descricaoRisco = this.objPrincipal.riscos.find(f => f.controle == this.riscoSelecionado).descricaoRisco;
			nova.posicao = this.objPrincipal.associados.length + 1;
			nova.controle = this.objPrincipal.associados.length + 1;

			this.objPrincipal.associados.push(nova);
		}
		else {
			this.objEditar.descricao = this.txtDescricaoControle;
			this.objEditar.descricaoMelhorPratica = this.txtMelhorPratica;
			this.objEditar.idControle = this.avaliacaoControleSelecionada;
			this.objEditar.descricaoControle = this.listAvaliacaoControle.find(f => f.id == this.avaliacaoControleSelecionada).avaliacao;
			this.objEditar.valorRI = this.txtValorRR;
			this.objEditar.valorCalculado = this.txtCalculoRR;
			this.objEditar.nivelRR = this.txtNivelRR;
			this.objEditar.controleRiscoControleRiscos = this.riscoSelecionado;
			this.objEditar.descricaoRisco = this.objPrincipal.riscos.find(f => f.controle == this.riscoSelecionado).descricaoRisco;
		}
		this.objPrincipal.associados = [...this.objPrincipal.associados];
		this.limpar();
		return this.objPrincipal.associados;
	}

	limpar() {
		this.objEditar = null;
		this.riscoSelecionado = 0;
		this.avaliacaoControleSelecionada = null;
		this.txtDescricaoControle = "";
		this.txtValorRR = "";
		this.txtCalculoRR = "";
		this.txtNivelRR = "";
		this.txtMelhorPratica = "";
	}

	editar(obj: IMatrizRiscoControleAssociado) {
		//console.log(obj);
		this.objEditar = obj;
		this.riscoSelecionado = obj.controleRiscoControleRiscos;
		this.avaliacaoControleSelecionada = obj.idControle;
		this.txtDescricaoControle = obj.descricao;
		this.txtValorRR = obj.valorRI;
		this.txtCalculoRR = obj.valorCalculado;
		this.txtNivelRR = obj.nivelRR;
		this.txtMelhorPratica = obj.descricaoMelhorPratica;
		setTimeout(() => {
			this.changeAvaliacao();
		}, 500);
	}

	remover(obj: IMatrizRiscoControleAssociado) {
		if (this.objPrincipal.testes.length > 0) {
			if (this.objPrincipal.testes.some(s => s.controleAssociado == obj.controle)) {
				this.exibirMensagemAlerta("Não possível remover esse controle, ele esta sendo usado na aba Testes!");
				return;
			}
		}

		if (obj.id > 0) {
			if (this.objPrincipal.associadosRemover == undefined)
				this.objPrincipal.associadosRemover = [];

			this.objPrincipal.associadosRemover.push(this.objPrincipal.associados.find(f => f.id === obj.id));
			this.objPrincipal.associados = this.objPrincipal.associados.filter(f => f.id !== obj.id);
		}
		else
			this.objPrincipal.associados = this.objPrincipal.associados.filter(f => f.posicao !== obj.posicao);

		this.objPrincipal.associados = [...this.objPrincipal.associados];
	}

	novo() {
		this.limpar();
	}

	getNameBtn() {
		if (this.objEditar == null)
			return "Adicionar";
		else
			return "Salvar";
	}
}
